import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { ReportsService } from 'src/app/services/reports.service';

@Component({
  selector: 'app-failed-pond-payment-s3',
  templateUrl: './failed-pond-payment-s3.component.html',
  styleUrls: ['./failed-pond-payment-s3.component.scss']
})
export class FailedPondPaymentS3Component implements OnInit {

  public tableData: any = [];
  public searchValue: any;
  public loading: boolean = false;
  public userId: any;
  public subscriptions: any = [];
  public subjectSub:any;
  public displayDialog: boolean = false;
  public tableData2: any = [];
  public lotType: any;
  public lotNumber: any;
  public ipAddress: any = '000.000.000';

  constructor(
    private route: ActivatedRoute,
    // private reportsService: ReportsService,
    private deptDashBoardService: DepartmentDashboardService, 
    private router: Router,
    private loader: AppLoaderService,
    public messageService: MessageService,
    private ipService: IpAddressService,
    private cryptoJsService: CryptoJsService
  ) { }

  ngOnInit(): void {
    this.getIP();
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;
    
    this.lotType = 'stage3';
    this.loadTableData(this.lotType, this.userId);
  }

  loadTableData(lotType, userId) {
    // this.loader.start();
    this.loading = true;
    let sub = this.deptDashBoardService
      .getPondConsolidatedFailedLotData(lotType, userId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loading = false;
          // this.loader.close();
          if(data.length > 0){
            this.tableData = data;
          }else{
            this.tableData = [];
          }
        },
        error: (err) => {
          this.loading = false;
          this.tableData = [];
          // this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

      this.subscriptions.push(sub);
  }

  ngOnDestroy() {
    this.loader.close();
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    if (this.subjectSub) {
      this.subjectSub.unsubscribe();
    }
  }

  onCloseDialog(){
    this.displayDialog = false;
    this.lotNumber = null;
    this.tableData2 = [];
  }

  onViewLot(lotNo){
    this.displayDialog = true;
    this.lotNumber = lotNo;
    this.loadPondData(this.lotType, lotNo);
  }

  loadPondData(lotType, lotNo) {
    // this.loader.start();
    this.loading = true;
    let sub = this.deptDashBoardService
      .getPondFailedLotData(lotType, lotNo)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loading = false;
          // this.loader.close();
          if(data.length > 0){
            this.tableData2 = data;
          }else{
            this.tableData2 = [];
          }
        },
        error: (err) => {
          this.loading = false;
          this.tableData2 = [];
          // this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

      this.subscriptions.push(sub);
  }

  updateLot(){
    let reqBody = {
      "lotType": this.lotType,
      "lotNo": this.lotNumber,
      "netWork_Id": this.ipAddress,
      "terminal_Id": this.ipAddress
    }

    this.updateLotData(reqBody);
  }

  updateLotData(reqBody) {
    // this.loader.start();
    this.loading = true;
    let sub = this.deptDashBoardService
      .updatePondFailedLot(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loading = false;
          // this.loader.close();
          if(data == "Success"){
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: data,
            });
            this.onCloseDialog();
          }else{
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: data,
            });
          }
        },
        error: (err) => {
          this.loading = false;
          this.tableData2 = [];
          // this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

      this.subscriptions.push(sub);
  }

  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    }else{
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress',JSON.stringify(this.ipAddress));
      });
    }
  }
}



